<template>
    <div class="home">
        <log-in v-if="!loggedIn" :loading="loading" :onLogIn="handleLogIn" :onFakeLogIn="handleFakeLogIn" />
        <register-form v-if="loggedIn && !registered" :user="user" />
        <user-panel v-if="loggedIn  && registered" :user="user" />
    </div>
</template>

<script>
    // @ is an alias to /src
    import LogIn from '@/components/LogIn/LogIn.vue';
    import RegisterForm from '@/components/Form/Form.vue';
    import Router from "../routing.js";
    import Cookies from "js-cookie";
    import Loader from "../components/Loader";
    import UserPanel from "../components/UserPanel/UserPanel";

    export default {
        name: 'home',
        data: function () {
          return {
              loggedIn: false,
              loading: true,
              registered: false,
              user: false
          }
        },
        mounted() {
            if(Cookies.get('apiKey')) {
                this.getUser();
            }
            else {
                this.loading = false;
            }
        },
        components:
        {
            UserPanel,
            Loader,
            RegisterForm,
            LogIn
        },
        methods: {
            handleLogIn: function (data) {
                this.loading = true;

                if(data.type == 'facebook') {
                    this.logInByFB();
                }
                else if(data.type == 'google') {
                    this.logInByGoogle(data);
                }
            },

            handleFakeLogIn: function () {
                this.loading = true;
                this.sendLogInRequest(
                    Router.generate('fake_log_in'),
                    {}
                );
            },
            logInByGoogle: function(data) {
                this.sendLogInRequest(
                    Router.generate('log_in_google'),
                    {token: data.token}
                );
            },
            logInByFB: function() {
                if (typeof FB === 'undefined') {
                    alert('Wyłącz adblocka, jeżeli chcesz zalogować się za pomocą Facebooka.');
                    location.reload();
                }

                FB.login((response) => {
                    if(response.status == 'connected') {
                        this.sendLogInRequest(
                            Router.generate('log_in_fb'),
                            {fbId: response.authResponse.accessToken}
                        );
                    }
                    else {
                        location.reload();
                    }
                });
            },
            sendLogInRequest: function(url, data) {
                this.$http.post(url, data).then(response => {
                    if(response && response.data && response.data.apiKey) {
                        Cookies.set('apiKey', response.data.apiKey, {expires: 365});
                        this.getUser();
                    }
                    else {
                        this.loading = false;
                    }
                }, () => {
                    this.loading = false;
                    Cookies.remove('apiKey');
                });
            },

            getUser() {
                this.$http.get(Router.generate('get_user'), Router.getAuthHeader())
                    .then(response => {
                        this.handleGetUserResponse(response);
                    }, response => {
                        this.loading = false;
                        Router.handleWrongRequest(response);
                    });
            },

            handleGetUserResponse(response) {
                this.user = response.data;
                this.registered = this.user.registered;
                this.loggedIn = true;
                this.loading = false;

                if(this.user.confirmed) {
                    window.location.replace(process.env.VUE_APP_API + '/login');
                }
            }
        }
    }
</script>
